import { OrderActions } from '@src/orders/domain/OrderList';
import * as yup from 'yup';

export const OrderActionsSchema = yup
  .string()
  .oneOf(Object.values(OrderActions))
  .defined();
